import React from 'react'
import { toast } from 'react-toastify'

import { requestCreateDynamicLink } from '../../../modules/portal-remote/portalService'
import withPortalId from '../../../modules/portal/withPortalId'

const withGenerateQRHandler = WrappedComponent => {
  return withPortalId(
    class GenerateQRHandler extends React.Component {
      state = {
        isLoading: false,
        qrCode: null,
        url: null,
      }

      // static getDerivedStateFromProps = (props, state) => {
      //   console.log(props.qrCode, state.qrCode)
      //   if (props.qrCode !== state.qrCode) {
      //     return {
      //       qrCode: props.qrCode,
      //       url: props.url,
      //     }
      //   }
      //   return null
      // }

      componentWillReceiveProps(nextProps) {
        if (nextProps.qrCode !== this.state.qrCode) {
          this.setState({
            qrCode: nextProps.qrCode,
            url: nextProps.url,
          })
        }
      }

      handleGenerateQRPortal = async () => {
        try {
          this.setState({ isLoading: true })

          const { qrCode, url } = await requestCreateDynamicLink(
            this.props.portalId,
          )
          this.setState({
            qrCode,
            url,
            isLoading: false,
          })
        } catch (error) {
          this.setState({ isLoading: false })
          toast.error(error.message)
        }
      }

      render() {
        return (
          <WrappedComponent
            onGenerateQRPortal={this.handleGenerateQRPortal}
            isLoading={this.state.isLoading}
            {...this.props}
            {...this.state}
          />
        )
      }
    },
  )
}

export default withGenerateQRHandler



// WEBPACK FOOTER //
// ./src/components/templates/dynamic-link/withGenerateQRHandler.js